import React from 'react';
import CardCover, { type Props } from './main.tsx';

// eslint-disable-next-line @atlassian/eng-health/no-barrel-files/disallow-reexports
export { CardCoverBackgroundImg } from './background-img';

// eslint-disable-next-line jira/import/no-anonymous-default-export
export default (props: Props) => <CardCover {...props} />;
